import {BoxesComponent} from './BoxesComponent';
import Swiper, {Autoplay, Pagination} from 'swiper';

export class RelatedReadingComponent extends BoxesComponent {
  containerName = 'related-reading';

  constructor() {
    super();

    this.initialize();

    this.addEventListeners();
  }

  initialize() {
    const sectionContainer = document.querySelector(`.${this.containerName}`);
    if (!sectionContainer) {
      return;
    }

    this.container = sectionContainer.querySelector('section.elementor-section');
    if (!this.container) {
      return;
    }

    Swiper.use([Autoplay, Pagination]);

    if (window.innerWidth <= 768) {
      this.createSlider();
    }
  }

  createSlider() {
    if (this.swiper) {
      return;
    }

    if (!this.container) {
      return;
    }

    this.container.classList.add('swiper-container');

    const wrapper = this.container.querySelector('.elementor-container');
    if (!wrapper) {
      return;
    }

    wrapper.classList.add('swiper-wrapper');

    const items = wrapper.querySelectorAll('.elementor-top-column');
    if (items.length) {
      Array.from(items).forEach((item) => {
        item.classList.add('swiper-slide');
      });
    }

    const pagination = document.createElement('div');
    pagination.classList.add('swiper-pagination');

    this.container.appendChild(pagination);

    const swiper = new Swiper(this.container, this.config);

    this.swiper = swiper;
  }

  destroySlider() {
    const swiper = this.swiper;
    if (!swiper) {
      return;
    }

    if (!this.container) {
      return;
    }

    this.container.classList.remove('swiper-container');

    const wrapper = this.container.querySelector('.elementor-container');
    if (!wrapper) {
      return;
    }

    wrapper.classList.remove('swiper-wrapper');

    const items = wrapper.querySelectorAll('.elementor-top-column');
    if (items.length) {
      Array.from(items).forEach((item) => {
        item.classList.remove('swiper-slide');
      });
    }

    const pagination = this.container.querySelector('.swiper-pagination');
    if (pagination) {
      pagination.remove();
    }

    swiper.destroy();
    this.swiper = null;
  }
}